# TinyMCE 6 (which HugeRTE forked) replaced the old { text, menu: [...], onclick }
# submenu shape with a dedicated nested menu item: addNestedMenuItem +
# getSubmenuItems, and onclick was renamed to onAction. The item is placed into
# the Insert menu by the "insertsubscriberquota" reference in config/hugerte.yml
# (subscriber_quota preset), so the old `context: "insert"` hint is no longer
# needed.
hugerte.PluginManager.add("subscriberquotaplugin", (editor) ->
  quotaItems = [
    { text: "Current Usage [e.g. 4,102 / 10,000 (41%)]", value: "%%current_usage%%" }
    { text: "Soft Limit [e.g. 10,000]",                   value: "%%soft_limit%%" }
    { text: "Hard Limit [e.g. 12,000]",                   value: "%%hard_limit%%" }
    { text: "Organization ID",                            value: "%%organization_id%%" }
    { text: "Organization URL",                           value: "%%organization_url%%" }
    { text: "Organization Name",                          value: "%%organization_name%%" }
    { text: "Subscriber Count [e.g. 4,102]",              value: "%%organization_subscriber_count%%" }
  ]

  editor.ui.registry.addNestedMenuItem("insertsubscriberquota", {
    text: "Subscriber quota"
    getSubmenuItems: ->
      quotaItems.map((item) ->
        {
          type: "menuitem"
          text: item.text
          onAction: -> editor.insertContent(item.value)
        }
      )
  })
)
